import TimeLine from './timeLine'
import TimeLineItem from './timeLineItem'

TimeLine.Item = TimeLineItem 

export default TimeLine